// extracted by mini-css-extract-plugin
export default {"buttonsNavigation":"RegisterNavigation_buttonsNavigation__KBhgw","firstStep":"RegisterNavigation_firstStep__gWWJy"};